const DefaultComponent = () => import('@/ui-overrides/default/pages/billing/index.vue');


export default {
	name: 'BillingMainPageWrapper',

	functional: true,

	render(h, context) {
		let component = DefaultComponent;

		const uiOverride = context.parent.$store.state.agency.default_ui;

		// TODO: async `import()` like for `DefaultComponent` above doesn't work here. Why? What am I doing wrong?
		try {
			const override = require(`@/ui-overrides/${uiOverride}/pages/billing/index.vue`);
			component = override.default;
		}
		catch (err) {
			context.parent.$log.debug(`No override found: ${err}`);
		}

		return h(
			component,
			context.data,
			context.children,
		);
	},
};
